import { api } from '../api';
import type { GoldConfig } from './goldConfig.types';

export const fetchGoldConfig = async (): Promise<GoldConfig | null> => {
  try {
    const res = await api.get<GoldConfig[]>('/v1/gold_configs');
    return res[0] ?? null;
  } catch (error) {
    console.error('Failed to fetch gold config:', error);
    return null;
  }
};
